export const iconFontAwesomeClothingFashionHatWizard = (
	<i className="fa-solid fa-hat-wizard"></i>
);
